/* eslint-disable react/no-danger */
import PropTypes from 'prop-types'
import useStyles from './embed.styles'

const providers = {
  youtube: (id, autoplay, props) => (
    <iframe
      src={`https://www.youtube.com/embed/${id}?autoplay=${autoplay ? 1 : 0}`}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
      title={`YouTube video ${id}`}
      {...props}
    />
  ),
  vimeo: (id, autoplay, props) => (
    <iframe
      src={`https://player.vimeo.com/video/${id}?autoplay=${autoplay ? 1 : 0}`}
      frameBorder="0"
      allowFullScreen
      title={`Vimeo video ${id}`}
      {...props}
    />
  ),
  contentful: (id, autoplay, props) => (
    <video
      width="100%"
      autoPlay={autoplay && ''}
      controls
      src={id}
      {...props}
    />
  ),
}

const embedComponent = (props) => {
  const s = useStyles()
  const {
    id,
    autoplay,
    provider,
  } = props

  if (!id || !providers[provider]) {
    return null
  }

  const embed = providers[provider](id, autoplay, props)

  return (
    <div className={s.embed} data-testid="embed">
      {embed}
    </div>
  )
}

const Embed = (props) => {
  return embedComponent(props)
}

Embed.propTypes = {
  provider: PropTypes.string,
  id: PropTypes.string,
  autoplay: PropTypes.bool,
}

export default Embed
